import { render, staticRenderFns } from "./chooseRole.vue?vue&type=template&id=0f7c70b6&scoped=true&"
import script from "./chooseRole.vue?vue&type=script&lang=js&"
export * from "./chooseRole.vue?vue&type=script&lang=js&"
import style0 from "./chooseRole.vue?vue&type=style&index=0&id=0f7c70b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7c70b6",
  null
  
)

export default component.exports